import { useContext } from "react";
import { DateRangeContext } from "../providers/DateRangeDataProvider";

export default function useDateRangeData() {
  const contextValue = useContext(DateRangeContext);
  return contextValue;
}